export class OAuth2Token {
    public readonly expiresAtIsoString: string;
    public readonly expiresAt: number;

    constructor(
        public readonly idToken: string,
        public readonly refreshToken: string,
        public readonly expiresIn: number,
        expiresTs: number | null = null
    ) {
        this.expiresAt = expiresTs ?? (new Date().getTime() + +expiresIn * 1000);
        this.expiresAtIsoString = new Date(this.expiresAt).toISOString();
    }

    public isExpired(): boolean
    {
        return new Date().getTime() > this.expiresAt;
    }
}
